import { Grid } from '@mui/material';
import SortableList, { SortableItem } from 'react-easy-sort';
import { IAssemblyComponent } from 'src/interfaces';

import { BackupComponent } from './BackupComponent';

interface BackupComponentListProps {
  components: Partial<IAssemblyComponent>[];
  sortable: boolean;
  onSortEnd?: (oldIndex: number, newIndex: number) => void;
  editable?: boolean;
  showSoftSellInfo?: boolean;
  disabled?: boolean;
  onDeletedBackupAssemblyComponent: (
    assemblyComponent: IAssemblyComponent,
  ) => void;
  handleBackupComponentSelection: (
    assemblyComponent: IAssemblyComponent,
  ) => void;
  rotations?: number;
}

export const BackupComponentList = ({
  components,
  sortable,
  onSortEnd,
  editable,
  showSoftSellInfo,
  disabled,
  onDeletedBackupAssemblyComponent,
  handleBackupComponentSelection,
  rotations,
}: BackupComponentListProps) => {
  const renderBackupComponent = (
    backupComponent: Partial<IAssemblyComponent>,
    id?: number | string,
  ) => (
    <Grid item xs={12} key={backupComponent.id ?? id}>
      <BackupComponent
        key={backupComponent.id}
        backupComponent={backupComponent}
        onDeletedBackupAssemblyComponent={onDeletedBackupAssemblyComponent}
        onBackComponentSelection={handleBackupComponentSelection}
        editable={editable}
        showSoftSellInfo={showSoftSellInfo}
        disabled={disabled}
        rotations={rotations}
      />
    </Grid>
  );

  if (sortable && onSortEnd) {
    return (
      <SortableList
        onSortEnd={onSortEnd}
        className="list"
        draggedItemClassName="dragged"
        lockAxis="y">
        {components.map((backupComponent, id) => (
          <SortableItem key={id}>
            {renderBackupComponent(backupComponent, id)}
          </SortableItem>
        ))}
      </SortableList>
    );
  }

  return <>{components.map(renderBackupComponent)}</>;
};
